import { TimeFrameUnit } from './TimeFrameUnit';
import { DissectedRelativeDate } from './types';

const findUnit = (relativeDate: string) => {
  if (/now-\d+h/.test(relativeDate)) return TimeFrameUnit.HOUR_AGO;
  if (/now\+\d+h/.test(relativeDate)) return TimeFrameUnit.HOUR_FROM_NOW;
  if (/now-\d+d/.test(relativeDate)) return TimeFrameUnit.DAY_AGO;
  if (/now\+\d+d/.test(relativeDate)) return TimeFrameUnit.DAY_FROM_NOW;
  if (/now-\d+m/.test(relativeDate)) return TimeFrameUnit.MONTH_AGO;
  if (/now\+\d+m/.test(relativeDate)) return TimeFrameUnit.MONTH_FROM_NOW;
  if (/now-\d+y/.test(relativeDate)) return TimeFrameUnit.YEAR_AGO;
  if (/now\+\d+y/.test(relativeDate)) return TimeFrameUnit.YEAR_FROM_NOW;
  return null;
};

const dissectRelativeDate = (
  relativeDate: string
): DissectedRelativeDate | null => {
  const unit = findUnit(relativeDate);
  const [, valueString] = relativeDate.match(/now[+-](\d+)[hdmy]/) || [];
  const value = parseInt(valueString, 10);
  if (!unit || isNaN(value)) return null;
  return { unit, value };
};

export { dissectRelativeDate };
